import { Swiper } from "antd-mobile";
import { useMemo, useState } from "react";
import { TrendFileItem, TrendItem } from "@/config/types/trend";
import "./PicSwiper.less";
import { isApp } from "@/utils/utils";
import sdicHomeEmit from "@/utils/prototal";

const PicSwiper = ({ data }: { data: TrendItem }) => {
  const [index, setIndex] = useState(0);

  const list = useMemo(() => {
    if (Array.isArray(data?.files)) {
      return data.files;
    }
    return [];
  }, [data?.files]);

  const handleClick = () => {
    if (!isApp() || !list.length) {
      return;
    }
    sdicHomeEmit("browseImage", {
      images: list.map((item) => ({ url: item.url || item.smallUrl, title: "" })),
      currIndex: index,
    });
  };

  if (!list.length) {
    return null;
  }

  return (
    <div className="picture-swiper-wrap">
      <Swiper
        className="picture-swiper"
        style={{
          "--track-padding": " 0 0 16px",
        }}
        onIndexChange={(index) => setIndex(index)}
      >
        {list.map((item: TrendFileItem) => (
          <Swiper.Item key={item.id} onClick={handleClick}>
            <img
              style={{ height: (+list?.[0].height * screen.width) / +list?.[0].width || "40vh" }}
              className="picture-item"
              src={item?.smallUrl}
              alt="图片"
            />
          </Swiper.Item>
        ))}
      </Swiper>
      <div className="swiper-pagination">
        {index + 1}/{list.length}
      </div>
    </div>
  );
};
export default PicSwiper;
